import { render } from "./App.vue?vue&type=template&id=56aef9d4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=56aef9d4&lang=css"

import exportComponent from "D:\\BeforeProgram\\technolog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__